<ng-container *ngIf="!isLoading">
  <div *ngIf="item?.drawingDecorator?.status == 1">
    <div
      class="cmsDrawing-last__item"
      [ngStyle]="
        styleService.getStyleRule(
          undefined,
          [tab.configurations.cardDrawing.background],
          [
            tab.configurations.cardDrawing.border,
            mainTemplate.globalVariables.borders
          ]
        )
      "
    >
      <div class="cmsDrawing-last__item-img-wrapper">
        <img [src]="item?.drawingDecorator?.imageUrl" class="btn-ico" />
      </div>

      <div class="cmsDrawing-last__item-content">

        <h3
        class="cmsDrawing-last__item-name"
        [ngStyle]="
          styleService.getStyleRule([
            tab.configurations.main.title,
            undefined,
            'heading4'
          ])
        "
        [innerHTML]="
          item?.drawingDecorator?.title
            | conditionalUppercase
              : styleService.getUppercaseValue(
                  tab.configurations.cardDrawing.title
                )
        "
      ></h3>


        <h3
          class="cmsDrawing-last__item-name"
          [ngStyle]="
            styleService.getStyleRule([
              tab.configurations.cardDrawing.balanceText,
              undefined,
              'heading4'
            ])
          "
        >
          {{
            item?.universalConnectorData.entry
              | conditionalUppercase
                : styleService.getUppercaseValue(
                    tab.configurations.cardDrawing.balanceText
                  )
          }}

          {{
            tab.configurations.cardDrawing.balance
              | conditionalUppercase
                : styleService.getUppercaseValue(
                    tab.configurations.cardDrawing.balanceText
                  )
          }}
        </h3>

        <div class="cmsDrawing-last__item-content-bottom">
          <div class="cmsDrawing-last__item-line"></div>

          <!-- Activated -->
          <button
            *ngIf="getButtonState(item) === 'activated'"
            class="cmsDrawing-last__item-btn-details"
            [disabled]="item?.buttonIsDisabled"
            [ngStyle]="
              styleService.getStyleRule(
                [tab.configurations.cardDrawing.buttonActivated.text],
                [tab.configurations.cardDrawing.buttonActivated.background],
                [tab.configurations.cardDrawing.buttonActivated.border]
              )
            "

          >
            {{
              tab.configurations.cardDrawing.buttonActivatedText
                ? tab.configurations.cardDrawing.buttonActivatedText
                : ("Drawing detail"
                  | conditionalUppercase
                    : styleService.getUppercaseValue(
                        tab.configurations.cardDrawing.buttonActivated.text
                      ))
            }}
          </button>

          <!-- PreActive -->
          <button
            *ngIf="getButtonState(item) === 'preActive'"
            [disabled]="item?.buttonIsDisabled"
            class="cmsDrawing-last__item-btn-details"
            (click)="activateJoingoDrawing(item)"
            [ngStyle]="
              styleService.getStyleRule(
                [tab.configurations.cardDrawing.buttonPreActive.text],
                [tab.configurations.cardDrawing.buttonPreActive.background],
                [tab.configurations.cardDrawing.buttonPreActive.border]
              )
            "
          >
            {{
              tab.configurations.cardDrawing.buttonPreActiveText
                ? tab.configurations.cardDrawing.buttonPreActiveText
                : ("Drawing detail"
                  | conditionalUppercase
                    : styleService.getUppercaseValue(
                        tab.configurations.cardDrawing.buttonPreActive.text
                      ))
            }}
          </button>

          <!-- Activate -->
          <button
            *ngIf="getButtonState(item) === 'activate'"
            [disabled]="item?.buttonIsDisabled"
            (click)="activateJoingoDrawing(item)"
            class="cmsDrawing-last__item-btn-details"
            [ngStyle]="
              styleService.getStyleRule(
                [tab.configurations.cardDrawing.buttonActivate.text],
                [tab.configurations.cardDrawing.buttonActivate.background],
                [tab.configurations.cardDrawing.buttonActivate.border]
              )
            "
          >
            {{
              tab.configurations.cardDrawing.buttonActivateText
                ? tab.configurations.cardDrawing.buttonActivateText
                : ("Drawing detail"
                  | conditionalUppercase
                    : styleService.getUppercaseValue(
                        tab.configurations.cardDrawing.buttonActivate.text
                      ))
            }}
          </button>


          <!-- Empty, Button is not visible -->
          <button
            *ngIf="getButtonState(item) === ''"
            class="cmsDrawing-last__item-btn-details"
            [disabled]="true"
          >
           <br />
          </button>
         
        </div>
      </div>
    </div>
  </div>

</ng-container>


